document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('.champ-menu-toggle');
  const nav = document.querySelector('.champ-nav');
  if (button && nav) {
    button.addEventListener('click', function () {
      const open = nav.classList.toggle('open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('open');
        button.setAttribute('aria-expanded', 'false');
      });
    });
  }

  const carousel = document.querySelector('[data-champ-carousel]');
  if (carousel) {
    const slides = Array.from(carousel.querySelectorAll('.hero-slide'));
    const dots = Array.from(carousel.querySelectorAll('.hero-dot'));
    const prev = carousel.querySelector('[data-slide-prev]');
    const next = carousel.querySelector('[data-slide-next]');
    let current = 0;
    let timer = null;
    let startX = null;
    let moved = false;

    function showSlide(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    function start() {
      clearInterval(timer);
      timer = setInterval(() => showSlide(current + 1), 5000);
    }
    function stop() { clearInterval(timer); }
    function goNext(e) { if (e) e.preventDefault(); showSlide(current + 1); start(); }
    function goPrev(e) { if (e) e.preventDefault(); showSlide(current - 1); start(); }

    dots.forEach(dot => dot.addEventListener('click', function () {
      showSlide(Number(this.dataset.slideTo));
      start();
    }));
    if (next) next.addEventListener('click', goNext);
    if (prev) prev.addEventListener('click', goPrev);

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);

    carousel.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      moved = false;
      stop();
    }, {passive:true});
    carousel.addEventListener('touchmove', function (e) {
      if (startX === null || e.touches.length !== 1) return;
      if (Math.abs(e.touches[0].clientX - startX) > 12) moved = true;
    }, {passive:true});
    carousel.addEventListener('touchend', function (e) {
      if (startX === null) return;
      const endX = e.changedTouches[0].clientX;
      const delta = endX - startX;
      if (Math.abs(delta) > 45) delta < 0 ? goNext() : goPrev();
      else start();
      startX = null;
      moved = false;
    }, {passive:true});

    carousel.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowRight') goNext(e);
      if (e.key === 'ArrowLeft') goPrev(e);
    });
    showSlide(0);
    start();
  }
});

/* Brand picker modal + live brand filter */
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('[data-brand-modal]');
  const openers = document.querySelectorAll('[data-open-brands]');
  const closers = document.querySelectorAll('[data-close-brands]');
  const filter = document.querySelector('[data-brand-filter]');
  const items = document.querySelectorAll('.modal-brand-item');

  function openBrands() {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('brand-modal-open');
    if (filter) { filter.value = ''; setTimeout(() => filter.focus(), 80); }
  }
  function closeBrands() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('brand-modal-open');
  }
  openers.forEach(el => el.addEventListener('click', function(e){
    e.preventDefault();
    openBrands();
  }));
  closers.forEach(el => el.addEventListener('click', closeBrands));
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeBrands(); });
  if (filter) {
    filter.addEventListener('input', function(){
      const q = filter.value.trim().toLowerCase();
      items.forEach(item => {
        const name = (item.dataset.brandName || '').toLowerCase();
        item.hidden = q && !name.includes(q);
      });
    });
  }
});
